<template>
  <div class="menu-container">
    <div class="menu-logo">
      <img src="@/assets/logo.png" alt="Logo" class="logo-img" />
      <span class="logo-text">翼查通</span>
    </div>
    <el-menu :default-active="activeIndex" class="sidebar-menu" @select="handleSelect" :unique-opened="true">


      <el-menu-item-group>
        <el-sub-menu index="1">
          <template #title>
            <el-icon>
              <HomeFilled />
            </el-icon>
            <span>控制台</span>
          </template>
          <el-menu-item index="1-1">首页</el-menu-item>
        </el-sub-menu>
        <!-- 基本信息管理 -->
        <el-sub-menu index="3">
          <template #title>
            <el-icon>
              <UserFilled />
            </el-icon>
            <span>用户管理</span>
          </template>
          <el-menu-item index="3-1">用户列表</el-menu-item>
        </el-sub-menu>

        <!-- 密码管理 -->
        <el-sub-menu index="4">
          <template #title>
            <el-icon>
              <Lock />
            </el-icon>
            <span>密码管理</span>
          </template>
          <el-menu-item index="4-1">修改密码</el-menu-item>
          <el-menu-item index="4-2">密码安全设置</el-menu-item>
        </el-sub-menu>

        <!-- 账号绑定管理 -->
        <el-sub-menu index="5">
          <template #title>
            <el-icon>
              <Link />
            </el-icon>
            <span>账号绑定管理</span>
          </template>
          <el-menu-item index="5-1">微信绑定</el-menu-item>
          <el-menu-item index="5-2">Google绑定</el-menu-item>
          <el-menu-item index="5-3">Twitter绑定</el-menu-item>
          <el-menu-item index="5-4">其他账号绑定</el-menu-item>
        </el-sub-menu>

        <!-- 用户权限管理 -->
        <el-sub-menu index="6">
          <template #title>
            <el-icon>
              <User />
            </el-icon>
            <span>用户权限管理</span>
          </template>
          <el-menu-item index="6-1">角色分配</el-menu-item>
          <el-menu-item index="6-2">权限控制</el-menu-item>
          <el-menu-item index="6-3">功能开关</el-menu-item>
        </el-sub-menu>

        <!-- 账户安全 -->
        <el-sub-menu index="7">
          <template #title>
            <el-icon>
              <Key />
            </el-icon>
            <span>账户安全</span>
          </template>
          <el-menu-item index="7-1">安全设置</el-menu-item>
          <el-menu-item index="7-2">账号锁定与解锁</el-menu-item>
          <el-menu-item index="7-3">IP登录监控</el-menu-item>
          <el-menu-item index="7-4">活动日志</el-menu-item>
        </el-sub-menu>

        <!-- 通知与提醒功能 -->
        <el-sub-menu index="8">
          <template #title>
            <el-icon>
              <Bell />
            </el-icon>
            <span>通知与提醒</span>
          </template>
          <el-menu-item index="8-1">电子邮件通知</el-menu-item>
          <el-menu-item index="8-2">短信通知</el-menu-item>
          <el-menu-item index="8-3">站内通知</el-menu-item>
        </el-sub-menu>



      </el-menu-item-group>


    </el-menu>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import {
  HomeFilled,
  User,
  UserFilled,
  Lock,
  Link,
  Key,
  Bell,
} from "@element-plus/icons-vue";

export default {
  name: "NavigationMenu",
  components: {
    HomeFilled,
    User,
    UserFilled,
    Lock,
    Link,
    Key,
    Bell,
  },
  setup() {
    const router = useRouter();
    const activeIndex = ref(localStorage.getItem('activeMenuIndex') || '1-1');

    const handleSelect = (key, keyPath) => {
      console.log(key, keyPath);
      activeIndex.value = key;
      localStorage.setItem('activeMenuIndex', key);
      
      switch (key) {
        case '1-1':
          router.push('/');
          break;
        case '3-1':
          router.push('/user-list');
          break;
        default:
          break;
      }
    };

    return {
      activeIndex,
      handleSelect,
    };
  },
};
</script>

<style scoped>
.menu-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.menu-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  min-height: 64px;
}

.logo-img {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  object-fit: contain;
}

.logo-text {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  font-family: "Microsoft YaHei", "PingFang SC", "Hiragino Sans GB", "WenQuanYi Micro Hei", "YaSiHei", "SimSun", sans-serif;
}

.sidebar-menu {
  font-family: "Microsoft YaHei", "PingFang SC", "Hiragino Sans GB", "WenQuanYi Micro Hei", "YaSiHei", "SimSun", sans-serif;
  flex: 1;
  border-right: 1px solid #e6e6e6;
  border-top: none;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  overflow-y: auto;
}

/* 菜单项字体样式 */
:deep(.el-menu-item),
:deep(.el-sub-menu__title) {
  font-family: "Microsoft YaHei", "PingFang SC", "Hiragino Sans GB", "WenQuanYi Micro Hei", "YaSiHei", "SimSun", sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.5px;
}

/* 子菜单项字体样式 */
:deep(.el-menu-item) {
  font-size: 15px;
  padding-left: 50px !important;
}

/* 菜单项悬停和激活状态 */
:deep(.el-menu-item:hover),
:deep(.el-menu-item.is-active),
:deep(.el-sub-menu__title:hover) {
  font-weight: 500;
}

:deep(.el-menu-item-group__title) {
  display: none;
  padding: 0;
}
</style>
